import { combineReducers } from "redux";
import expressInterest from "features/Investors/ExpressInterestForm/expressInterestSlice";

const investorModule = combineReducers({
  expressInterest,
});

export default investorModule;
